import React from 'react'
import PropTypes from 'prop-types'
import MamagerEmailVerifyAction from 'components/Actions/ManagerEmailVerify'

const ManagerEmailVerifyPage = ({ match }) => (
  <MamagerEmailVerifyAction token={match.params.token} />
)

ManagerEmailVerifyPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default ManagerEmailVerifyPage
